export const pos = "pos";
export const kiosk = "kiosk";
export const mobile = "mobile";
export const web = "web";
